import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * 建立送印背景工作 → 201（只建立 job，不等列印完成）。
 * POST `/mom/work-order/{id}/sn-label-jobs`
 * body：`printerProfile`、`labelType`；`serialStart`／`serialEnd` 同時省略＝整段。
 * 不送 IP／port／網址／完整 SN。
 */
export async function createWorkOrderSnLabelJob(workOrderId, payload) {
  const { data: raw } = await request.post(
    `/mom/work-order/${workOrderId}/sn-label-jobs`,
    keysToSnake(serializeSnLabelJobCreate(payload)),
  );
  return parseVer4DetailResponse(raw);
}

export function serializeSnLabelJobCreate(payload = {}) {
  const body = {
    printerProfile: payload.printerProfile,
    labelType: payload.labelType,
  };
  if (!payload.wholeRange) {
    body.serialStart = Number(payload.serialStart);
    body.serialEnd = Number(payload.serialEnd);
  }
  return body;
}
